import api from '../../../api/clinique/_analyses'

const state = () => ({
    analyses: [],
    analyses_selected: [],
    analyses_selected2: [],
    categoriesAnalyse: [],
    bonAnalyse: [],
    analyses_en_cours: [],
    analyses_for_consult: [],
    bon_analyses: [],
    ref_bon_analyse: '',

    liste_analyse_externe: [],
    bon_analyse_sans_consultation: [],
    
    bons_analyse_factures: [],
})

// getters
const getters = {
    analyses: (state) => {
        return state.analyses
    },

    analyses_selected: (state) => {
        return state.analyses_selected
    },

    categoriesAnalyse: (state) => {
        return state.categoriesAnalyse
    },

    bonAnalyseStored: (state) => {
        return state.bonAnalyse;
    },

    analyses_en_cours: (state) => {
        return state.analyses_en_cours
    },

    analyses_for_consult: (state) => {
        return state.analyses_for_consult
    },

    bon_analyses: (state) => {
        return state.bon_analyses
    },

    ref_bon_analyse: (state) => {
        return state.ref_bon_analyse
    },

    liste_analyse_externe: (state) => {
        return state.liste_analyse_externe
    },

    bon_analyse_sans_consultation: (state) => {
        return state.bon_analyse_sans_consultation
    },

    bons_analyse_factures: (state) => {
        return state.bons_analyse_factures;
    },
}

// mutations
const mutations = {
    SET_ANALYSES(state, analyse) {
        state.analyses = analyse
    },

    SET_ANALYSES_SELECTED(state, analyse) {
        state.analyses_selected = analyse
    },

    SET_CATEGORIE_ANALYSE(state, cat) {
        state.categoriesAnalyse = cat
    },

    SET_BON_ANALYSE(state, bon) {
        state.bonAnalyse = bon;
    },

    SET_ANALYSE_EN_COURS(state, bon) {
        state.analyses_en_cours = bon;
    },

    SET_ANALYSE_FOR_CONSULT(state, an) {
        state.analyses_for_consult = an;
    },

    SET_BON_ANALYSES(state, analyses) {
        state.bon_analyses = analyses;
    },

    SET_REF_BON_ANALYSE(state, ref) {
        state.ref_bon_analyse = ref;
    },

    SET_LISTE_ANALYSE_EXTERNE(state, analyse) {
        state.liste_analyse_externe = analyse;
    },

    SET_BON_ANALYSE_SANS_CONSULTATION(state, bon) {
        state.bon_analyse_sans_consultation = bon;
    },

    SET_BONS_ANALYSE_FACTURES(state, bon) {
        state.bons_analyse_factures = bon;
    },
}

// actions
const actions = {
    getAnalyses({ commit }) {
        api.getAnalyses().then((response) => {
            commit("SET_ANALYSES", response);
        });
    },
    getCategoriesAnalyse({ commit }) {
        api.getCategoriesAnalyse().then((response) => {
            commit("SET_CATEGORIE_ANALYSE", response);
        });
    },

    getAnalysesEnCours({ commit }) {
        return new Promise((resolve) => {
            api.getAnalysesEnCours().then((response) => {
                commit("SET_ANALYSE_EN_COURS", response);
                resolve(response);
            });
        });
    },
    
    getAnalysesForConsult({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getAnalysesForConsult(data.consultation_id, data.bought).then(
                (response) => {
                    // console.log("respppppppppp", response)
                    commit("SET_ANALYSE_FOR_CONSULT", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    selectAnalyse({ commit }, { id, data }) {
        return new Promise((resolve, reject) => {
            api.selectAnalyse(id, data).then(
                response => {
                    commit;
                    resolve(response);

                }, error => {
                    reject(error)
                }
            )
        })
    },

    updateBulAnalyse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.updateBulAnalyse(data).then(
                (response) => {
                    // commit("SET_OPERATION", response);
                    resolve(response);
                    console.log("retour", commit);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    solderAnalyseDiffere({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.solderAnalyseDiffere(data).then(
                (response) => {
                    resolve(response);
                    console.log("retour", commit);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    storeBonAnalyse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.storeBonAnalyse(data.idPatient, data).then(
                (response) => {
                    commit("SET_BON_ANALYSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    savePendingAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.savePendingAnalyse(data).then(
                (response) => {
                    dispatch
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getAllAnalysesForExterne({ commit }) {
        return new Promise((resolve, reject) => {
            api.getAllAnalysesForExterne().then(
                (response) => {
                    commit("SET_LISTE_ANALYSE_EXTERNE", response)
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getBulletinAnalyseSanConsultation({ commit }) {
        return new Promise((resolve, reject) => {
            api.getBulletinAnalyseSanConsultation().then(
                (response) => {
                    commit("SET_BON_ANALYSE_SANS_CONSULTATION", response)
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    /**
     * Récupère le prix assurance d'une liste d'analyse
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    getPrixAssurBonAnalyse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getPrixAssurBonAnalyse(data).then(
                response => {
                    commit("SET_BON_ANALYSES", response);
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getRefBonAnalyse({ commit }) {
        return new Promise((resolve, reject) => {
            api.getRefBonAnalyse().then(
                response => {
                    commit("SET_REF_BON_ANALYSE", response);
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getBonAnalyseFacture({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getBonAnalyseFacture(data).then(
                (response) => {
                    commit('SET_BONS_ANALYSE_FACTURES', response)
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}